import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material";

const TokenContainer = styled(Container)`
    background-color:#860C0A;
    padding-top:150px;
    padding-bottom:150px;
    display:flex;
    justify-content:center;
    @media (max-width: 1024px){
        padding-top:60px;
        padding-bottom:60px;
    }
`
const ContentWrapper =styled(Grid)`
    background-color:#141414;
    padding:90px 40px;
    border-radius:71px;
    @media (max-width: 1024px){
        padding:40px 20px;
    }
`

const Heading = styled(Typography)`
    color:#fff;
    font-size:80px;
    font-family:Oswald-bold;
    @media (max-width: 900px){
        font-size:40px;
    }
`
const TokenomicsWrapper = styled.div`
    background-color:#1E1E1E;
    border-radius:21px;
    display:block;
    padding:20px 20px;
    @media (max-width: 1024px){
        padding:10px 10px;
    }
`
const Firstp = styled.p`
    color:#C42927;
    font-family:Oswald-semibold;
    font-size:20px;    
    margin: 0px;
    @media (max-width: 900px){
        font-size:16px;
    }
`
const SecondP = styled.p`
    color:#fff;
    font-family:Oswald-semibold;
    font-size:20px;
    text-align:right;
    margin: 0px;
    @media (max-width: 900px){
        font-size:16px;
    }
`
const ContractP = styled.p`
    color:#fff;
    font-family:Oswald-semibold;
    font-size:20px;
    text-align:left;
    margin: 0px;
    @media (max-width: 900px){
        font-size:16px;
    }
`
const ContractWrapper = styled.div`
    display:flex;
    justify-content:space-between;
    background-image:linear-gradient(to bottom, #D5312F, #700100);
    border-radius:10px;
    padding:10px 14px;
`
const DetailGrid = styled(Grid)`
    padding-left:8px !important;
    padding-right:8px !important;
    margin:8px 0px;
`
function Tokenomics(){
    return(
        <TokenContainer maxWidth="xxl" id="tokenomics">
            <ContentWrapper container item xs={12} sm={12} md={12} lg={12} xl={8}>
                <DetailGrid item xs={12}>
                    <Heading variant="h1">Tokenomics</Heading>
                </DetailGrid>
                <DetailGrid item xs={12} sm={6}>
                    <TokenomicsWrapper>
                        <Firstp>Name</Firstp>
                        <SecondP>Luffy</SecondP>
                    </TokenomicsWrapper>
                </DetailGrid>
                <DetailGrid item xs={12} sm={6}>
                    <TokenomicsWrapper>
                        <Firstp>Supply</Firstp>
                        <SecondP>TBA</SecondP>
                    </TokenomicsWrapper>
                </DetailGrid>
                <DetailGrid item xs={12} sm={6}>
                    <TokenomicsWrapper>
                        <Firstp>Taxes</Firstp>
                        <SecondP>TBA</SecondP>
                    </TokenomicsWrapper>
                </DetailGrid>
                <DetailGrid item xs={12} sm={6}>
                    <TokenomicsWrapper>
                        <Firstp>Max Wallet</Firstp>
                        <SecondP>TBA</SecondP>
                    </TokenomicsWrapper>
                </DetailGrid>
                <DetailGrid item xs={12}>
                    <ContractWrapper>
                        <ContractP>Max Wallet</ContractP>
                        <SecondP>TBA</SecondP>
                    </ContractWrapper>
                </DetailGrid>
            </ContentWrapper>
        </TokenContainer>
    );
}

export default Tokenomics;